// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_fXZmp clearfix","list":"index_list_zs7uk"};